export type PlanLimits = readonly [bigint, bigint, bigint, bigint, bigint]; // tiers 1..5

/**
 * Fallback limits — used while contract read is pending.
 * Real values come from allowedDnmAmountStake(1..5) contract read.
 */
export const PLAN_DNM_LIMITS_FALLBACK_WEI: PlanLimits = [
  28_000_000_000_000_000_000n, // tier 1: 28 DNM
  14_000_000_000_000_000_000n, // tier 2: 14 DNM
  7_000_000_000_000_000_000n, // tier 3: 7 DNM
  2_800_000_000_000_000_000n, // tier 4: 2.8 DNM
  1_400_000_000_000_000_000n, // tier 5: 1.4 DNM
];

/**
 * Returns the max DNM allowed (in wei) for a given plan tier (1-indexed).
 */
export function maxDnmForPlan(plan: number, limits: PlanLimits): bigint {
  const idx = plan - 1;
  if (idx < 0 || idx >= limits.length) return limits[0];
  return limits[idx];
}

/**
 * Returns true when dnmWei is within the valid range for the given plan.
 * Uses STAKE_MIN_DNM_WEI (1 ether) as the lower bound.
 */
export function isDnmInRange(
  dnmWei: bigint,
  plan: number,
  limits: PlanLimits,
): boolean {
  const MIN = 1_000_000_000_000_000_000n; // STAKE_MIN_DNM_WEI
  const max = maxDnmForPlan(plan, limits);
  return dnmWei >= MIN && dnmWei <= max;
}
